import React, { Suspense } from 'react';
import { useParams } from 'react-router';
import bem from 'utils/bem';
import Page from '../Page';
import { App, AppSkeleton } from './App';
import Model from '../../../model';
import './index.sass';

const { block, el } = bem('conference-page');

export const Conference = () => {
    const { user: { userOrderData } } = Model;
    const { orderId } = useParams();
    const orderData = userOrderData(orderId);

    return (
        <Page className={ block() }>
            <div className={ el('content') }>
                <Suspense fallback={<AppSkeleton />}>
                    <App orderData={ orderData } orderId={ orderId } />
                </Suspense>
            </div>
        </Page>
    )
}
